module.exports = __webpack_public_path__ + "img/CaptainMarvel_B_01.8158f2b5.png";